module.exports = __webpack_public_path__ + "static/media/thumbnail.6c4f3ad3.jpg";